import { Modal, NDSProvider } from "@nulogy/components";
import { ConfirmModalContextProvider } from "contexts/ConfirmModalContext";
import { GlobalStateProvider } from "contexts/GlobalStateContext";
import { NetworkStateProvider } from "contexts/NetworkStateContext";
import { UIStateProvider } from "contexts/UIStateContext";
import { WorkOrderSearchProvider } from "contexts/WorkOrderSearchContext";
import ApplicationContext from "domain/ApplicationContext";
import useApplicationContext from "hooks/apollo/applicationContext/useApplicationContext";
import React from "react";
import { BrowserRouter } from "react-router-dom";
import styled from "styled-components";
import NotificationContainer from "./common/NotificationContainer";
import Pendo from "./common/Pendo";
import ErrorBoundary from "./ErrorBoundary";
import GqlProvider from "./GqlProvider";
import ApplicationLayoutContainer from "./layouts/ApplicationLayoutContainer";
import isolateModalsFromSparkReset from "./layouts/spark/isolateModalsFromSparkReset";
import Router from "./Router";
import "./App.styles.scss";

const BranchDisplay = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  font-size: 12px;
  color: var(--spark-appshell-sidenav-ink);
  background: var(--spark-appshell-sidenav-elevated);
  padding: 4px;
`;

function Branch() {
  const applicationContext = useApplicationContext();
  if (applicationContext.loading) return null;
  if (!applicationContext.branch || applicationContext.branch === "main") return null;

  return <BranchDisplay>{applicationContext.branch}</BranchDisplay>;
}

function StateProviders({ children }) {
  const applicationContext = useApplicationContext();
  if (applicationContext.loading) return null;

  const sessionIdentifier = ApplicationContext.sessionIdentifier(applicationContext);

  return (
    <GlobalStateProvider>
      <UIStateProvider sessionIdentifier={sessionIdentifier}>
        <ConfirmModalContextProvider>
          <NetworkStateProvider>
            <WorkOrderSearchProvider sessionIdentifier={sessionIdentifier}>{children}</WorkOrderSearchProvider>
          </NetworkStateProvider>
        </ConfirmModalContextProvider>
      </UIStateProvider>
    </GlobalStateProvider>
  );
}

const App = (
  <ErrorBoundary>
    <NDSProvider>
      <GqlProvider>
        <StateProviders>
          <Pendo>
            {/* Above the layout, so the shell can read the current path to mark the rail's active page. */}
            <BrowserRouter>
              <ApplicationLayoutContainer>
                <NotificationContainer />
                <Router />
                <Branch />
              </ApplicationLayoutContainer>
            </BrowserRouter>
          </Pendo>
        </StateProviders>
      </GqlProvider>
    </NDSProvider>
  </ErrorBoundary>
);

Modal.setAppElement(document.getElementById("root"));
isolateModalsFromSparkReset();

export default App;
